import React, { useEffect } from "react";
import SelectTag from "./SelectTag";
import { useQualityData } from "../../context/QualityDataContext";
import { useSelectTagContext } from "../../context/SelectTagContext";
import ResponsiveDatePickers from "./ResponsiveDatePickers";
import dayjs from "dayjs";

function ByPartsFilter() {
  const { partsData } = useQualityData();
  const { selectedFilters, setSelectedFilters } = useSelectTagContext();

  const handleFromDateChange = (date) => {
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      fromTimestamp: date,
    }));
  };

  const handleToDateChange = (date) => {
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      toTimestamp: date,
    }));
  };

  const SelectTagData = {
    prediction: ["All", "Suspicious", "Good"]
  };

  // useEffect(()=>{
  //   console.log("--->",selectedFilters.fromTimestamp)
  // },[selectedFilters])

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
        <ResponsiveDatePickers
          label="From"
          defaultValue={selectedFilters.fromTimestamp}
          minDate={null}
          maxDate={dayjs()}
          onChange={handleFromDateChange}
        />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
        <ResponsiveDatePickers
          label="To"
          defaultValue={selectedFilters.toTimestamp}
          minDate={selectedFilters.fromTimestamp}
          maxDate={dayjs()}
          onChange={handleToDateChange}
        />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
        <SelectTag
          label="Prediction"
          options={SelectTagData.prediction}
          fieldName={"prediction"}
          value={selectedFilters ? selectedFilters.prediction : ""}
        />
      </div>
    </div>
  );
}

export default ByPartsFilter;
